import { CancelToken } from 'axios'

import { portalApi } from '@/axios'

import { Business, Merchant } from '@/classes/models'

export default class BusinessService {
  /**
   * Get all businesses.
   *
   * @param {PaginationRequest} parameters
   *
   * @return {Promise}
   */
  static getAll (parameters) {
    const cancelToken = CancelToken.source()

    let request = portalApi.get(this.endpoint(), {
      cancelToken: cancelToken.token,
      params: parameters ? parameters.getParams() : null
    }).then(response => {
      return response.data
    })

    request.then(response => {
      // Set pagination
      response.totalCount = response.numberOfResults

      // Map to Business
      response.data = response.results.map(business => {
        return new Business(business)
      })

      return response
    }).catch(error => {
      return Promise.reject(error)
    })

    return { request, cancelToken }
  }

  /**
   * Get a business by id.
   *
   * @param {string} id
   *
   * @return {Promise}
   */
  static get (id) {
    let request = portalApi.get(`${this.endpoint()}/${id}`).then(response => {
      return response.data
    })

    return request.then(response => {
      // Map to Business
      return new Business(response)
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Get the merchants by business.
   *
   * @param {Context} context
   * @param {PaginationRequest} parameters
   *
   * @return {Promise}
   */
  static getMerchants ({ business }, parameters) {
    let request = portalApi.get(`${this.endpoint()}/${business.id}/merchants`, {
      params: parameters ? parameters.getParams() : null
    }).then(response => {
      return response.data
    })

    return request.then(response => {
      // Set pagination
      response.totalCount = response.numberOfResults

      // Map to Merchant
      response.data = response.results.map(merchant => {
        return new Merchant(merchant)
      })

      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Get the merchant by business and merchant id.
   *
   * @param {Context} context
   *
   * @return {Promise}
   */
  static getMerchant ({ business, merchant }) {
    let request = portalApi.get(`${this.endpoint()}/${business.id}/merchants/${merchant.id}`).then(response => {
      return response.data
    })

    return request.then(response => {
      // Map to Merchant
      return new Merchant(response)
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Endpoint of API.
   *
   * @return {string}
   */
  static endpoint () {
    return '/businesses'
  }
}
